var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4422 7.43606C15.4411 7.4345 15.4406 7.43255 15.4409 7.43064L16.7142 0.00591737C16.7148 0.00249867 16.7178 0 16.7212 0H17.1242C17.1273 0 17.1301 0.00201539 17.131 0.00497801L19.9997 9.08788C20.0006 9.09068 19.9996 9.0938 19.9973 9.09563L17.8821 10.747C17.879 10.7495 17.8744 10.7489 17.872 10.7456L15.4422 7.43606ZM0 12.3581C0 12.3612 0.00198012 12.3639 0.00490746 12.3649L4.36499 13.7905C4.3671 13.7912 4.36944 13.7908 4.37127 13.7896L14.1171 7.06133C14.1187 7.0602 14.1198 7.05844 14.1201 7.05649L15.1652 0.0439871C15.1658 0.0396835 15.1625 0.0358165 15.1582 0.0358165H6.52579C6.52365 0.0358165 6.52166 0.0367599 6.5203 0.0383933L0.00163825 7.90216C0.000579269 7.90345 0 7.90505 0 7.90673V12.3581ZM6.18186 14.1537L10.9452 15.714C10.9473 15.7147 10.9497 15.7144 10.9515 15.7131L16.6226 11.6452C16.6257 11.643 16.6265 11.6387 16.6243 11.6355L14.4984 8.47188C14.4962 8.46857 14.4918 8.46771 14.4885 8.46997L6.18186 14.1537Z",
    fill: "#8BCEC1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRock);
export default __webpack_public_path__ + "static/media/rock.5bbbd45b52a14845b64b1c22f5e60281.svg";
export { ForwardRef as ReactComponent };